function closeEnquiryModal(modal) {
  if (!modal) return;
  modal.hidden = true;
  document.documentElement.classList.remove('t4s-enquiry-open');

  // reset to form view for next time
  const form = modal.querySelector('.t4s-enquiry-form');
  const success = modal.querySelector('.t4s-enquiry-success');
  if (form) form.hidden = false;
  if (success) success.hidden = true;

  // optionally reset fields
  if (form) form.hidden = false;
if (success) success.hidden = true;

  if (form) form.reset();
}

document.addEventListener('click', (e) => {
  const openBtn = e.target.closest('[data-enquiry-open]');
  if (openBtn) {
    const id = openBtn.getAttribute('data-enquiry-open');
    const modal = document.getElementById(id);
    if (modal) {
      modal.hidden = false;
      document.documentElement.classList.add('t4s-enquiry-open');

      const first = modal.querySelector('.t4s-enquiry-form input, .t4s-enquiry-form select, .t4s-enquiry-form textarea');
      if (first) first.focus();
    }
    return;
  }

  const closeEl = e.target.closest('[data-enquiry-close]');
  if (closeEl) {
    const modal = closeEl.closest('.t4s-enquiry-modal');
    closeEnquiryModal(modal);
    return;
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const modal = document.querySelector('.t4s-enquiry-modal:not([hidden])');
    closeEnquiryModal(modal);
  }
});

// AJAX submit -> show premium confirmation
document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (!form || !form.classList.contains('t4s-enquiry-form')) return;

  e.preventDefault();
  e.stopPropagation();

  const modal = form.closest('.t4s-enquiry-modal');
  const submitBtn = form.querySelector('button[type="submit"]');
  const success = modal ? modal.querySelector('.t4s-enquiry-success') : null;

  try {
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.textContent = 'Sending...';
    }

    const res = await fetch(form.action.split('#')[0], {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    // Shopify contact returns HTML; treat 200/302 as success
    if (!res.ok) throw new Error('Request failed');

    // swap form -> success
    form.hidden = true;
    if (success) success.hidden = false;

  } catch (err) {
    // fallback: allow normal submit if AJAX fails
    form.submit();
  } finally {
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.removeAttribute('aria-busy');
      submitBtn.textContent = 'Send enquiry';
    }
  }
}, true);
